export const QualityItem = ({ field, formProps, icon }) => {
  return (
    <div className="QualityItem">
      <div className="QualityItem__wrapper">
        <div className="QualityItem__content">
          {/* Icono renderizado dinámicamente (SVG o IMG) */}
          {icon}

          {/* Etiqueta vinculada al input para mejorar la accesibilidad */}
          <label htmlFor={field.name} className="QualityItem__label">
            {field.label}
          </label>
        </div>

        {/* Checkbox de Formik */}
        <input
          type="checkbox"
          id={field.name}
          name={field.name}
          className="QualityItem__checkbox"
          checked={formProps.values[field.name] || false}
          onChange={(ev) =>
            formProps.setFieldValue(field.name, ev.target.checked)
          }
        />
      </div>
    </div>
  );
};
